import Cookies from 'js-cookie';

// Used to validate any email address
const validateEmail = (val) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(val).toLowerCase())
}

//group price_indicator_data 
const getGroupedLineData = (array, filterYear) => {
  const filteredData = array.map(item => {
    return {
      id: item.id,
      data: item.data.reduce((group, year) => {
        const { x } = year;
        let getYear = x.split(' ')[1];
        group[getYear] = group[getYear] || []
        group[getYear].push(year);
        return group;
      }, {})[filterYear]
    }
  });
  return filteredData;
}


// This function checks if the user exists and returns a boolean
const userExists = (val) => {
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken')
  }
  let resp = fetch("/user-api/exists/?email=" + encodeURIComponent(val), {
    method: 'GET',
    headers: headers
  })

  return resp
}


// data should include valid credentials eg. {"password": password, "email": email}
const loginUser = (data) => {
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken')
  }

  let resp = fetch("/user-api/login/", {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  });

  return resp
}

// data should include valid required registration fields. (PASSWORD is optional) eg: {"email": email, "muni": muni, "roles": roles, "mobile_phone_number": mobile_phone_number}
const registerUser = (data) => {
  try {
    window.lintrk('track', { conversion_id: 14716858 });
    uet_report_conversion();
  } catch (error) {
    console.log(error);
  }
  
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken')
  }
  let resp = fetch("/user-api/register/", {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  });

  return resp
}


const getUserRights = () => {
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken')
  }

  let resp = fetch("/user-api/rights/", {
    method: 'GET',
    headers: headers
  })

  return resp;
}


const getDistrubution = (tree, muni) => {
  let headers = {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken'),
    //'Authorization': CRED,
  }
  let prms = fetch("/price-api/distributions?municipality=" + muni.toString() + "&tree=" + tree.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: headers
  })
  return prms;
}

const getPulp = (tree, muni) => {
  let headers = {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken'),
    //'Authorization': CRED,
  }

  let prms = fetch("/price-api/pulp?municipality=" + muni.toString() + "&tree=" + tree.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: headers
  })

  return prms;
}


const getTimber = (tree, muni) => {
  let headers = {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken'),
    //'Authorization': CRED,
  }

  let prms = fetch("/price-api/timber?municipality=" + muni.toString() + "&tree=" + tree.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: headers
  })

  return prms;
}

const getBuyer = (muni) => {
  let headers = {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken'),
    //'Authorization': CRED,
  }

  let prms = fetch("/price-api/buyers?municipality=" + muni.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: headers
  })

  return prms;
}

const getPrice = (tree, muni) => {
  let headers = {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken'),
    //'Authorization': CRED,
  }

  let prms = fetch("/price-api/avg-price?municipality=" + muni.toString() + "&tree=" + tree.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: headers
  })

  return prms;
}


export { getGroupedLineData, validateEmail, userExists, loginUser, registerUser, getUserRights, getDistrubution, getPulp, getTimber, getBuyer, getPrice };